import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import { useHome } from "../../translations/home";
import { TeamsFrame } from "../TeamsFrame";
import { LiveLevelCard } from "../LiveLevelCard";
import { DemoCTA } from "./DemoCTA";

const HomeHero = () => {
  const { language } = useLanguage();
  const h = useHome(language).hero;

  return (
    <section className="relative bg-white pt-28 pb-16 lg:pt-32 lg:pb-20 overflow-hidden" data-testid="hero-section">
      <div
        className="absolute inset-x-0 top-0 h-[560px] pointer-events-none"
        style={{ background: "linear-gradient(180deg, rgba(94,179,246,0.10) 0%, rgba(255,255,255,0) 100%)" }}
        aria-hidden="true"
      />
      <div className="wrap-cayus relative">
        <div className="grid lg:grid-cols-[55fr_45fr] gap-12 lg:gap-14 items-center">
          {/* Colonne gauche : la promesse */}
          <div>
            <div className="rule-cobalt mb-5 reveal-cascade" />
            <p className="mono-cayus text-cobalt-600 mb-4 reveal-cascade d-1" data-testid="hero-eyebrow">
              {h.eyebrow}
            </p>

            <h1
              className="font-extrabold text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.06] tracking-[-0.035em] text-inkc-800 mb-6 reveal-cascade d-2"
              data-testid="hero-headline"
            >
              <span className="text-inkc-500 font-bold">{h.h1a}</span> {h.h1b}
            </h1>

            <p className="text-lg text-inkc-600 leading-relaxed mb-8 max-w-[34rem] reveal-cascade d-3" data-testid="hero-sub">
              {h.sub}
            </p>

            <div className="flex flex-wrap items-center gap-x-7 gap-y-4 reveal-cascade d-4">
              <DemoCTA from="hero" align="left" />
              <Link
                to="/methodologie"
                className="text-sm font-medium text-cobalt-600 nav-underline hover:text-cobalt-700 transition-colors"
                data-testid="hero-secondary-link"
              >
                {h.secondary}
              </Link>
            </div>
            <p className="text-sm text-inkc-400 mt-3 reveal-cascade d-4" data-testid="hero-cta-sub">
              {useHome(language).cta.sub}
            </p>

            <div className="flex flex-wrap gap-2 mt-8 reveal-cascade d-5" data-testid="hero-mono-badges">
              {h.badges.map((b, i) => (
                <span
                  key={i}
                  className="mono-cayus text-inkc-500 bg-surfacec-50 border border-linec-200 rounded-md px-3 py-1.5"
                  data-testid={`hero-badge-${i}`}
                >
                  {b}
                </span>
              ))}
            </div>
          </div>

          {/* Colonne droite : le produit */}
          <div className="relative reveal-cascade d-6">
            <div className="rounded-2xl shadow-[0_40px_80px_-40px_rgba(10,35,66,0.45)]">
              <TeamsFrame src="/assets/product/01-manager-two-clocks.webp" alt={h.caption} caption={h.caption} />
            </div>
            <LiveLevelCard />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
